import {useMemo} from 'react';
import {useRouter} from 'next/router';
import {useGetStockQuery} from 'modules/stock-x/services';

export const useCurrentStockXData = () => {
    const {query} = useRouter();
    const slug = useMemo(() => (query.slug as string[] | undefined)?.[0] ?? null, [query.slug]);

    const result = useGetStockQuery(slug as string, {skip: !slug});

    return {
        ...result,
    };
};
